<template>
  <div id="app">
    <el-container v-if="data !== null">
      <el-header height="223px">
        <app-header select="0" @isLecturer="isLecturer"></app-header>
      </el-header>
      <el-main>
        <app-main :pageData="data"></app-main>
      </el-main>
      <el-footer>
        <app-foter></app-foter>
      </el-footer>
    </el-container>
    <app-loading v-if="!data"></app-loading>
  </div>
</template>

<script>
import AppLoading from "@/components/Loading.vue";
import AppHeader from "@/components/Header.vue";
import AppMain from "./components/Main.vue";
import AppFoter from "@/components/Foter.vue";

export default {
  name: "app",
  components: {
    AppLoading,
    AppHeader,
    AppMain,
    AppFoter
  },
  data() {
    return {
      data: {
        category_data: [], // 分类
        study_type: [], //学习培训分类
        banner_data: [], // 顶部滚动图片
        hot_keywords_data: [], // 热门知识点
        lib_stats_data: [], // 文库统计
        ency_stats_data: [], // 知识点统计
        class_stats_data:[],//课程统计
        authority_data: [], // 权威发布
        experts_data: [], // 专家观点
        class_data: [], //精选课程
        popularity_ranking_data: [[], [], []], // 综合排行榜
        browse_ranking_data: [[], [], []], // 浏览排行榜
        download_ranking_data: [[], [], []], // 下载排行榜
        class_ranking_data: [], //学习排行榜
        ad_data: [], // 下部广告
        cs_data: [], // 精品课程下链接
        link_data: [], // 友情链接
        hot_ency_data: [],
        lecture:0
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    isLecturer(index){
      console.log('index',this.data)
      this.data.lecture = index
      this.$forceUpdate()
    },
    getData() {
      // 分类
      this.$api.home
        .getCategory()
        .then(res => {
          let [category_data, child_data, categorys] = [[], [], []];
          res.data.data.forEach(item => {
            child_data = [];
            item.child_data.forEach(val => {
              child_data.push({
                category_name: val.name,
                category_no: val.no,
                url: val.url
              });
            });
            category_data.push({
              category_name: item.name,
              category_no: item.no,
              url: item.url,
              child_data: child_data
            });
            categorys.push({
              category_name: item.name,
              category_no: item.no,
              data: []
            });
          });
          this.data.category_data = category_data;
          // 权威发布
          this.data.authority_data = JSON.parse(JSON.stringify(categorys));
          this.$api.home
            .authority(this.data.authority_data[0].category_no)
            .then(res => {
              this.data.authority_data[0].data = res.data.data;
            })
            .catch();
          // 专家观点
          this.data.experts_data = JSON.parse(JSON.stringify(categorys));
          this.$api.home
            .experts(this.data.experts_data[0].category_no)
            .then(res => {
              this.data.experts_data[0].data = res.data.data;
            });
        })
        .catch();

      // 精品课程

      this.$api.study
        .getCourseList({
          commend: 1,
          size: 3
        })
        .then(res => {
          this.data.class_data = res.data.data;
          // 执行某些操作
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });

      // 学习培训分类
      this.$api.study
        .getCourseType()
        .then(res => {
          this.data.study_type = res.data.data;
          // 执行某些操作
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });

      // 顶部滚动图片
      this.$api.home
        .topPic()
        .then(res => {
          this.data.banner_data = res.data.data;
        })
        .catch();
      // 热门知识点
      this.$api.home
        .hotEncy()
        .then(res => {
          this.data.hot_keywords_data = res.data.data;
        })
        .catch();
      // 文库统计
      this.$api.home
        .statsLib()
        .then(res => {
          this.data.lib_stats_data = res.data.data;
        })
        .catch();
      // 知识点统计
      this.$api.home
        .statsEncy()
        .then(res => {
          this.data.ency_stats_data = res.data.data;
        })
        .catch();
        // 课程统计
        
        this.$api.study
        .getCourseTotal()
        .then(res => {
          this.data.class_stats_data = res.data.data;
        })
        .catch();

      // 权威发布
      // this.$api.home.authority().then(res => {
      //     // this.data.authority_data = res.data.data;
      //   })
      //   .catch();
      // 专家观点
      // this.$api.home.experts().then(res => {
      //     // this.data.experts_data = res.data.data;
      //   })
      //   .catch();
      // 排行榜
      let params = [
        {
          time: "today",
          key: "today_data"
        },
        {
          time: "week",
          key: "week_data"
        },
        {
          time: "month",
          key: "month_data"
        }
      ];
      // 综合排行榜
      this.$api.home
        .ranking("hot", "today")
        .then(res => {
          this.data.popularity_ranking_data.splice(0, 1, {
            today_data: res.data.data
          });
        })
        .catch();
      // 浏览排行榜
      this.$api.home
        .ranking("click", "today")
        .then(res => {
          this.data.browse_ranking_data.splice(0, 1, {
            today_data: res.data.data
          });
        })
        .catch();
      // 下载排行榜
      // this.$api.home
      //   .ranking("download", "today")
      //   .then(res => {
      //     this.data.download_ranking_data.splice(0, 1, {
      //       today_data: res.data.data
      //     });
      //   })
      //   .catch();

      // 学习排行榜

      this.$api.study
        .getTodayrank()
        .then(res => {
          this.data.class_ranking_data = res.data.data;
          
          // this.data.download_ranking_data.splice(0, 1, {
          //   today_data: res.data.data
          // });
        })
        .catch();

      // 下部广告
      this.$api.home
        .ad()
        .then(res => {
          this.data.ad_data = res.data.data;
        })
        .catch();

      // 精品课程下广告
      this.$api.study
        .getBanner({
          classId: "007011",
          position: "004002"
        })
        .then(res => {
          this.data.cs_data = res.data.data;
        })
        .catch();
      // 友情链接
      this.$api.home
        .link()
        .then(res => {
          this.data.link_data = res.data.data;
        })
        .catch();
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
li {
  list-style-type: none;
}
#app {
  width: 100vw;
  height: 100vh;
  min-width: 1250px;
  font-family: "PingFangSC-Regular", "PingFang SC", "Microsoft YaHei", Arial,
    Helvetica, "WenQuanYi Micro Hei", "tohoma,sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f5f5;
  .el-header,
  .el-main,
  .el-footer {
    padding: 0;
  }
  .el-footer {
    height: auto !important;
  }
  .iconfont {
    color: #7f7f7f;
  }
}
</style>
